import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { GlobalContext } from './App'
import { metodoPrograma } from './components/api'

export const ModalAgendaSelected = () => {
  const [listAgendas, setListAgendas] = useState([])
  const { agenda, dispatch, localAtendimento } = useContext(GlobalContext)

  const buscarListaAgendas = useCallback(() => {
    metodoPrograma(
      'listaAgenda',
      { idLocalAtendimento: localAtendimento ? localAtendimento[0] : null },
      'CtrlAgendamento',
    ).then((res) => {
      if (res.status) {
        setListAgendas(res.lista)
        if (res.lista && res.lista.length === 1 && !res.lista[0][4]) {
          dispatch({ type: 'setAgenda', value: res.lista[0] })
        }
      }
    })
  }, [localAtendimento, dispatch])

  const buscaDadosMedico = useCallback(
    (cdMedico) => {
      metodoPrograma('buscaDadosMedico', { cdMedico }, 'CtrlAgendamento').then(
        (res) => {
          if (res.status) {
            dispatch({ field: 'medico', value: res })
          }
        },
      )
    },
    [dispatch],
  )

  useEffect(() => {
    if (localAtendimento !== null) {
      const savedAgenda = JSON.parse(localStorage.getItem('selectedAgenda'))
      if (savedAgenda !== null) {
        buscaDadosMedico(savedAgenda[2])
        dispatch({ type: 'setAgenda', value: savedAgenda })
      }
      buscarListaAgendas()
    }
  }, [buscaDadosMedico, buscarListaAgendas, dispatch, localAtendimento])
  return (
    <Dialog
      open={
        listAgendas.length > 0 && localAtendimento !== null && agenda === null
      }
    >
      <DialogTitle>Selecione a agenda</DialogTitle>
      <DialogContent>
        {listAgendas === null ? (
          <p>Nenhuma agenda disponível.</p>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              padding: '10px',
            }}
          >
            {listAgendas.map((agenda) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '10px',
                  border: '1px solid gray',
                  borderRadius: '7px',
                  cursor: 'pointer',
                }}
                key={agenda[0]}
                onClick={() => {
                  dispatch({ type: 'setAgenda', value: agenda })
                  buscaDadosMedico(agenda[2])
                }}
              >
                {agenda[1]}
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
